import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './useAuth.js'

// Cognito surfaces Hosted UI / IdP failures via the `error` + `error_description`
// query params instead of a JSON body. A bare message like "invalid_request" is
// unhelpful, so we map the common cases to something actionable.
const OIDC_ERROR_MESSAGES = {
  access_denied: 'Sign-in was cancelled or denied by your identity provider.',
  login_required: 'Your identity provider requires re-authentication. Please try again.',
  interaction_required: 'Your identity provider needs additional verification. Please try again.',
  unauthorized_client: 'This app is not authorized with your identity provider. Contact your admin.',
  invalid_request: 'The sign-in request was rejected by your identity provider.',
}

function extractOidcError() {
  const params = new URLSearchParams(window.location.search)
  const err = params.get('error')
  if (!err) return null
  const description = params.get('error_description')
  return OIDC_ERROR_MESSAGES[err] || description || err
}

export function CallbackHandler() {
  const { handleCallback } = useAuth()
  const navigate = useNavigate()
  const [error, setError] = useState(null)

  useEffect(() => {
    const oidcError = extractOidcError()
    if (oidcError) {
      setError(oidcError)
      return
    }
    handleCallback()
      .then(() => {
        navigate('/', { replace: true })
      })
      .catch((err) => {
        setError(err.message || 'Sign in failed')
      })
  }, [handleCallback, navigate])

  if (error) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <p style={styles.error}>{error}</p>
          <a href="/" style={styles.link}>Try again</a>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <p style={styles.text}>Signing in...</p>
      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fafaf9',
    backgroundImage: 'url(/login-bg.svg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  card: {
    background: '#ffffff',
    border: '1px solid #e8e8e6',
    borderRadius: '12px',
    padding: '40px',
    textAlign: 'center',
  },
  text: { color: '#6b6b6b', fontSize: '13px' },
  error: { color: '#e85d5d', fontSize: '13px', marginBottom: '12px' },
  link: { color: '#1a1a1a', fontSize: '13px' },
}
